'use client'

import useSWR from 'swr'

export type BrandConfig = {
  name: string
  community: string
  sellerName: string
  screenname: string
  customDomain?: string

  logos?: {
    square?: string | null
    horizontal?: string | null
    square_dark?: string | null
    horizontal_dark?: string | null
  }

  banner?: string | null

  welcomeAvatar?: string | null
  welcomeOnboarding?: string | null

  background?: {
    dark?: string
    light?: string

    // opcional: deja image como fallback legacy
    image?: string

    mode?: 'image' | 'color' | 'gradient'
    blur?: boolean
    darken?: number
  } | null

  onboardingBackground?: {
    dark?: string
    light?: string

    // opcional: deja image como fallback legacy
    image?: string

    mode?: 'image' | 'color' | 'gradient'
    blur?: boolean
    darken?: number
  } | null

  defaultThemeMode: 'light' | 'dark' | null

  colors?: {
    primary?: string | null
    secondary?: string | null
    accent?: string | null
  }

  ui?: {
    glass?: {
      enabled?: boolean
      intensity?: 'low' | 'medium' | 'high'
    }
    darkModeRecommended?: boolean
  }
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include' }).then((r) => r.json())

export function useBranding(sellerId?: number | null) {
  const { data, error, isLoading } = useSWR(
    sellerId ? `/api/branding?sellerId=${sellerId}` : null,
    fetcher
  )

  return {
    brand: (data?.ok ? data.brand : null) as BrandConfig | null,
    loading: isLoading,
    error,
  }
}